import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Focus = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.49996 2.99994C1.49999 2.17154 2.17155 1.5 2.99996 1.5H5C5.27614 1.5 5.5 1.72386 5.5 2C5.5 2.27614 5.27614 2.5 5 2.5H2.99996C2.72382 2.5 2.49997 2.72385 2.49996 2.99998L2.49988 5.00002C2.49987 5.27616 2.276 5.50001 1.99986 5.5C1.72372 5.49999 1.49987 5.27612 1.49988 4.99998L1.49996 2.99994ZM1.99986 10.5C2.276 10.5 2.49987 10.7238 2.49988 11L2.49996 13C2.49997 13.2762 2.72382 13.5 2.99996 13.5H5C5.27614 13.5 5.5 13.7239 5.5 14C5.5 14.2761 5.27614 14.5 5 14.5H2.99996C2.17155 14.5 1.49999 13.8285 1.49996 13.0001L1.49988 11C1.49987 10.7239 1.72372 10.5 1.99986 10.5ZM14.5 13C14.5 13.8284 13.8284 14.5 13 14.5H11C10.7239 14.5 10.5 14.2761 10.5 14C10.5 13.7239 10.7239 13.5 11 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V11C13.5 10.7239 13.7239 10.5 14 10.5C14.2761 10.5 14.5 10.7239 14.5 11V13ZM14 5.5C13.7239 5.5 13.5 5.27614 13.5 5L13.5 3C13.5 2.72386 13.2761 2.5 13 2.5L11 2.5C10.7239 2.5 10.5 2.27614 10.5 2C10.5 1.72386 10.7239 1.5 11 1.5H13C13.8284 1.5 14.5 2.17157 14.5 3L14.5 5C14.5 5.27614 14.2761 5.5 14 5.5ZM9.5 8C9.5 8.82843 8.82843 9.5 8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8ZM10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8Z"
      />
    </svg>
  )
})

export default Focus
